$(document).ready(function () {
  $('.toggle-item--btn').on('click', function () {
    $(this).toggleClass('active');
    $(this).parent('.toggle-item').toggleClass('active');
  });
});